module.exports = __webpack_public_path__ + "static/media/Refil.d4e91fc6.png";